export interface Database {
  name: string
  slug: string
}

export const databases: Database[] = [
  { name: 'MySQL', slug: 'mysql' },
  { name: 'PostgreSQL', slug: 'postgresql' },
  { name: 'Redis', slug: 'redis' },
  { name: 'MongoDB', slug: 'mongodb' },
  { name: 'Microsoft SQL Server', slug: 'mssql' },
  { name: 'TiDB', slug: 'tidb' },
  { name: 'XtraDB', slug: 'percona' },
  { name: 'PostgreSQL HA', slug: 'postgressqlha' },
  { name: 'Meilisearch', slug: 'meilisearch' },
  { name: 'RabbitMQ', slug: 'rabbitMQ' },
  { name: 'Elasticsearch', slug: 'elasticsearch' },
  { name: 'MariaDB', slug: 'mariadb' },
]
